import { z } from 'zod';
/** Zod schema for validating the full-text search request body. */
export const legislativeItemFullSearchBodySchema = z.object({
    query: z.string().default(''),
    legislativeTypeId: z.number().int().optional(),
    legislativeStatusId: z.number().int().optional(),
    /** ISO date string — only return items published on or after this date */
    publishedAfter: z.string().optional(),
    /** ISO date string — only return items published on or before this date */
    publishedBefore: z.string().optional(),
    /** When true, only return items that require a public hearing */
    publicHearing: z.boolean().optional(),
    limit: z.number().int().min(1).max(50).default(20),
    offset: z.number().int().min(0).default(0),
});
